let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aDFb6")).then(() => parcelRequire('2zBDm'));